export default __webpack_public_path__ + "static/media/Sirius.f6dc736a.svg";